.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-family: var(--font-body);
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  /*
   * `contracts/DESIGN-TOKENS.md` § Control metrics (`APP-013`): 14px text and 18px of side
   * padding. `--text-sm` already held 0.875rem, so this is an existing token rather than a
   * literal; 18px has none, and inventing a spacing token for one use would be worse than
   * writing the measurement where it applies.
   *
   * The contract's 44px minimum sets the height, overruling the canvas's own 11px of block
   * padding, which at 14px text would land the control near 39px. A target below 44px is
   * not a fidelity win (WCAG 2.5.8).
   */
  min-block-size: 44px;
  padding-block: var(--space-3);
  padding-inline: 1.125rem;
  font-size: var(--text-sm);
  transition: background-color var(--duration-fast) ease, border-color var(--duration-fast) ease,
    color var(--duration-fast) ease;
}

.button:disabled,
.button[aria-disabled="true"] {
  cursor: not-allowed;
  opacity: 0.55;
}

.lg {
  min-block-size: 52px;
  padding-inline: var(--space-6);
  font-size: var(--text-lg);
}

.primary {
  background: var(--accent);
  color: var(--accent-contrast);
}

.primary:hover:not(:disabled) {
  background: var(--accent-strong);
  color: var(--accent-contrast);
}

.secondary {
  background: var(--surface-elevated);
  border-color: var(--border-strong);
  color: var(--text);
}

.secondary:hover:not(:disabled) {
  border-color: var(--accent);
  color: var(--accent-strong);
}

.quiet {
  background: transparent;
  color: var(--accent);
  padding-inline: var(--space-3);
}

.quiet:hover:not(:disabled) {
  background: var(--accent-soft);
  color: var(--accent-strong);
}
